module.exports = __webpack_public_path__ + "fonts/Lato-Regular.27bd77b9.woff";